import React from 'react';
import styles from './CategoryCard.module.scss';
import { CategoryCardGridProps } from './types';

const CategoryCardGrid: React.FC<CategoryCardGridProps> = ({ id, children }) => (
  <div className={styles.grid_container}>
    <div id={id} className={styles.grid}>
      {children}
    </div>
  </div>
);

export default CategoryCardGrid;
